(() => {
    const hero = document.querySelector('.hero-image');
    if (!hero) return;

    const getImgs = () => Array.from(document.querySelectorAll('.hero-image__machine img'));

    const mqMobile = window.matchMedia('(max-width: 640px)');
    let ticking = false;

    const heroBottomDoc = () => hero.offsetTop + hero.offsetHeight;
    const getFadeRange = () => (mqMobile.matches ? 180 : 320);

    const updateFade = () => {
        const imgs = getImgs();
        if (!imgs.length) { ticking = false; return; }

        const range = getFadeRange();
        const y = window.scrollY || window.pageYOffset;
        const end = heroBottomDoc();
        const start = end - range;

        let opacity;
        if (y <= start) opacity = 1;
        else if (y >= end) opacity = 0;
        else opacity = 1 - ((y - start) / (end - start));

        imgs.forEach(img => { img.style.opacity = String(opacity); });
        ticking = false;
    };

    const onScroll = () => {
        if (!ticking) {
            requestAnimationFrame(updateFade);
            ticking = true;
        }
    };

    if (mqMobile.addEventListener) {
        mqMobile.addEventListener('change', updateFade);
    } else {
        mqMobile.addListener(updateFade);
    }

    updateFade();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateFade);
    window.addEventListener('orientationchange', updateFade);
    window.addEventListener('DOMContentLoaded', updateFade);
})();
